"use strict";
exports.__esModule = true;
var shopId = '607d65c542b6201e93c03c14';
var location = 'https://chantecaille-cbd.ecommercepartners.net';
var config = {
    apiUrl: location + "/api/storefront/shop/" + shopId + "/"
};
exports["default"] = config;
